import AppHeader from "../../layout/AppHeader";
import FinancialType from '../../xpost/views/financial/type/FinancialType.vue';
import FinancialTypeAdd from '../../xpost/views/financial/type/FinancialTypeAdd.vue';

const FinancialTypeRoutes = [
    {
        path: "/financeiro/tipo",
        name: "financial.type",
        components: {
            header: AppHeader,
            default: FinancialType,
        }
    },
    {
        path: "/financeiro/tipo/adicionar",
        name: "financial.type.add",
        components: {
            header: AppHeader,
            default: FinancialTypeAdd,
        }
    },
    {
        path: '/financeiro/tipo/adicionar/:id',
        name: 'financial.type.edit',
        components: {
            header: AppHeader,
            default: FinancialTypeAdd,
        }
    }
]

export default FinancialTypeRoutes;